export enum ListAdminUsersOrderBy {
  Forenames,
  Surname,
  Email,
  CreatedDateUtc,
  IsActive,
  Client,
  Division
}
